import React from 'react';
const noopSeparators = {
    highlight: () => { },
    unhighlight: () => { },
    updateProps: () => { },
};
/**
 * Renders list rows inline, with no ScrollView of their own.
 *
 * Use this instead of `<FlatList scrollEnabled={false}>` inside another
 * ScrollView. On web, react-native-web gives a non-scrolling ScrollView
 * `touch-action: none`, which stops a touch that starts on any row from
 * panning the outer ScrollViews. That made the Meal Map grid impossible to
 * swipe on phones and tablets.
 */
export function StaticRows({ data, renderItem, keyExtractor, }) {
    return (<>
      {data.map((item, index) => (<React.Fragment key={keyExtractor(item, index)}>
          {renderItem({ item, index, separators: noopSeparators })}
        </React.Fragment>))}
    </>);
}
